import React, { useEffect, useState } from "react";
import { Button, Divider, Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans, InputDate, SelectWithSearch, TableComponent, ActionComponent, FlowHistoryButton } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { Commons, Const } from "../../../constants";
import moment from "moment/moment";
import dayjs from 'dayjs';
import { approveRequest } from "../requests";
import CreateConsent from "@mods/common/CreateConsent";
import CreateConsentChat from "@mods/common/CreateConsentChat";
import EmployeeInfo from '@mods/common/EmployeeInfo';
const langKey = Const["promotionApproval"].lngKey
const formName = "updatePromotionApproval";

const UpdatePromotionApproval = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [consents, setConsents] = useState([]);
  const [creatConsentModal, setCreateConsentModal] = useState(null);
  const [loading, setLoading] = useState(false)
  const [designations, setDesignations] = useState([]);
  const [jobtitles, setJobtitles] = useState([]);
  const [grades, setGrades] = useState([]);
  const [childComponent, setChildComponent] = useState(null)
  const [form] = Form.useForm()
  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, []);
  const setData = () => {

    setConsents(props.record.consents)
    //setGrades(createSelectList(props.allData.grades))
    //(createSelectList(props.allData.designations))
    //setJobtitles(createSelectList(props.allData.job_titles))

    form.setFieldsValue(
      {
        employment_id: props.record.requestor.full_name_code,
        grade_id: props.record.requestor.grade_name,
        designation_id: props.record.requestor.designation_name,
        job_title_id: props.record.requestor.jobtitle_name,
        is_demotion: props.record.is_demotion,
        prev_salary: props.record.prev_salary,
        salary: props.record.salary,
        date: dayjs(props.record.date),
        description: props.record.description,
        last_remarks: props.record.last_remarks,

      }
    )
  }

  //===========constents =============
  const onCreateConsent = () => {
    setCreateConsentModal(<CreateConsent onCreatedConsent={ onCreatedConsent } employment_id={ props.record.employment_id } request_id={ props.record.id } request_as={ props.requestAsId } api="promotionApprovals/createConsent" />)
  }
  const onCreatedConsent = (response) => {
    if (response) {
      message.success("Consent created successfully");
      props.onCompleted(response.promotions.data);
    }
    setCreateConsentModal(null)
  }
  const onConsentChat = (record) => {
    setCreateConsentModal(<CreateConsentChat record={ record } onCreatedConsent={ onCreatedConsent } request_as={ props.requestAsId } api="promotionApprovals/messageConsent" />)
  }
  //============end consents================================
  const onSubmit = (isApproval) => {
    const last_remarks = form.getFieldValue('last_remarks');
    let requestObj = { request: { ...props.record, current_history: { ...props.record.current_history, remarks: last_remarks }, last_remarks: last_remarks, remarks: last_remarks, request_as: props.requestAsId, is_approval: isApproval }, delegator_id: props.delegatorId, api: props.api, filters: props.filters }

    const payload = requestObj
    makeRequest(setLoader, approveRequest, payload, onSuccess, onError);
  }
  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.promotions.data);
  }
  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //----------------------
  const consentColumns = [
    {
      key: 'consentor_name',
      title: trans(`${langKey}.consentor_name`),
      dataIndex: 'consentor_name'
    },
    {
      key: 'consentee_name',
      title: trans(`${langKey}.consentee_name`),
      dataIndex: 'consentee_name'
    },
    {
      key: 'consent_date',
      title: trans(`${langKey}.consent_date`),
      render: (record) => {
        return record.created_at ? moment(record.created_at).format('DD-MM-YYYY h:mm:ss a') : null
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => (
        <ActionComponent
          each={ record } modkey={ props.modkey }
          onView={ onConsentChat }
        ></ActionComponent>
      ),
    },
  ]
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    childComponent,
    <div style={ { float: 'left' } }>
      < FlowHistoryButton record={ props.record } setChildComponent={ setChildComponent } />
    </div>,
    props.disabled ? '' :
      <SaveButton disabled={ props.disabled } loading={ saveLoader } form={ formName } key="create_button" onClick={ () => onSubmit(true) } text='Approve' />,
    props.disabled ? '' :
      <CancelButton disabled={ saveLoader } key="reject_button" form={ formName } htmlType='submit' text='Reject' onClick={ () => onSubmit(false) } />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
      mainTitle={ trans(props.disabled ? Commons.view : Commons.update) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <EmployeeInfo record={ props.record.requestor && props.record.requestor } />
        <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } disabled={ true } >
          <Divider>Promotion Request</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_demotion" rules={ rules.is_demotion } label={ trans(`${langKey}.is_demotion`) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ [
                    {
                      label: 'Promotion',
                      value: false
                    },
                    {
                      label: 'Demotion',
                      value: true
                    },
                  ] }
                  placeholder={ trans(`${langKey}.is_demotion`) }

                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="grade_id" rules={ rules.grade_id } label={ trans(`${langKey}.grade_id`) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.grade_id`) }
                  options={ grades }
                />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="designation_id" rules={ rules.designation_id } label={ trans(`${langKey}.designation_id`) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.designation_id`) }
                  options={ designations }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="job_title_id" rules={ rules.job_title_id } label={ trans(`${langKey}.job_title_id`) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.job_title_id`) }
                  options={ jobtitles }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="prev_salary" rules={ rules.prev_salary } label={ trans(`${langKey}.prev_salary`) }
                className="da-mb-16"
                { ...getErrorProps(errors['prev_salary']) } size="small"
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.prev_salary`) } disabled={ true } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="salary" rules={ rules.salary } label={ trans(`${langKey}.salary`) }
                className="da-mb-16"
                { ...getErrorProps(errors['salary']) } size="small"
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.salary`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="date" rules={ rules.date } label={ trans(`${langKey}.date`) }
                className="da-mb-16"
                { ...getErrorProps(errors['date']) } size="small"
              >
                <InputDate />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="description" rules={ rules.description } label={ trans(`${langKey}.description`) }
                className="da-mb-16"
                { ...getErrorProps(errors['description']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.description`) } />
              </Form.Item>
            </Col>
          </Row>
          <Divider>Approval</Divider>

          <Form.Item name="last_remarks" rules={ rules.remarks } label={ trans(`${langKey}.remarks`) }
            className="da-mb-16"
            { ...getErrorProps(errors['remarks']) } size="small"
          >
            <InputTextArea placeholder={ trans(`${langKey}.last_remarks`) } />
          </Form.Item>

        </Form>

        {
          props.disabled ? '' : <h5 className="formlist-title" style={ { paddingTop: 0 } }>Consents <Button type="primary" title='Create' onClick={ onCreateConsent } className="float-end me-5">Create</Button></h5>
        }

        { creatConsentModal }
        <TableComponent dataSource={ consents } columns={ consentColumns } />
      </Skeleton>
    </ModalComponent>
  )
}

export default UpdatePromotionApproval

const rules = {
  name: [
    { required: true, message: '' },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}